import { SELECT_VEHICLE } from './constants';
import { VEHICLE_QUERY_PARAM, OFFERID_QUERY_PARAM } from '../constants';
import { ALL_VEHICLES_FLAG_VALUE } from '../selectors/constants';
import {
  addParamToURL,
  findParam,
  pushState,
  replaceParamOnURL,
  removeParamFromURL,
  removeAllParamsFromURL,
} from '../queryParams';

export function selectVehicle(data) {
  if (typeof data.model !== 'undefined') {
    window.ModelData = {
      model: data.model,
      modelYear: 'no model',
    };
  }
  return {
    type: SELECT_VEHICLE,
    data,
  };
}

export function updateQueryAfterVehicleChange(data) {
  return () => {
    const vehicle = data.model.toLowerCase().replace(' ', '-');
    let url = '';
    url = removeAllParamsFromURL();

    if (vehicle !== ALL_VEHICLES_FLAG_VALUE.toLowerCase().replace(' ', '-')) {
      url = addParamToURL(VEHICLE_QUERY_PARAM, vehicle, false);
    }

    pushState(url);
  };
}

export function checkDefaultVehicle() {
  return (dispatch, getState) => {
    const state = getState();

    if (state.defaultModelGroup) {
      const matchingVehicles = state.vehicles.filter((vehicle) => vehicle.model.toLowerCase().replace(' ', '-')
        === state.defaultModelGroup.toLowerCase().replace(' ', '-'));
      if (matchingVehicles.length) {
        dispatch(selectVehicle({
          model: state.defaultModelGroup,
        }));
      }
    }
  };
}

export default selectVehicle;
